import React from 'react';
import { useTranslations } from '../../hooks/use-translations';
import { ModalDisplayMode } from '../../typing/modal-display';
import ModalWithLayer from '../modal-with-layer';

interface ModalDisplayFactoryProps {
  mode?: ModalDisplayMode;
  modalProps: any;
}
const ModalDisplayFactory: React.FC<ModalDisplayFactoryProps> = (props) => {
  const { mode, modalProps } = props;
  const translations = useTranslations().modals;
  switch (mode) {
    case ModalDisplayMode.TRIM_MODULE_DETAILS:
      return (
        <ModalWithLayer {...modalProps} translations={translations.trimModuleDetails} />
      );
    default:
      return <div>Error: UNKNOWN MODAL MODE</div>;
  }
};

export default ModalDisplayFactory;
